var height1 = 220; //只有一行导航栏
var height2 = 483; //一行导航栏，6个分类筛选
var height3 = 317; //一行导航栏，2个分类筛选
var height4 = 270; //一行导航栏，tabs切换
var height5 = 347; //一行导航栏，3个分类筛选
export { height1, height2, height3, height4, height5 };

// import { height1 } from "@/utils/height";
